export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.6.18-1240.53",
  commitId: "9bd901896a927db7a326669979f57624a6eea594",
  commitTime: "2026-06-18T12:40:53.000Z",
});
